import { Spacer, Text } from '@vinted/web-ui'
import classNames from 'classnames'

import {
  InfoBoardPostLayoutType,
  InfoBoardPostModel,
} from '@marketplace-web/info-board/info-board-data'

const InfoPost = ({ id, title, subtitle, body, layoutType }: InfoBoardPostModel) => {
  const classes = classNames('payments-explanation__container', {
    'about__hero-section payments-explanation__section':
      layoutType === InfoBoardPostLayoutType.NoBackground,
    'about__hero-section about__hero-section--with-background payments-explanation__section payments-explanation__section--terms':
      layoutType === InfoBoardPostLayoutType.WithBackground,
  })

  return (
    <section id={`info-post-${id}`} className={classes}>
      <div className="payments-explanation__section-content">
        <Text as="span" alignment={Text.Alignment.Left}>
          <span className="c-text--responsive-large-heading">{title}</span>
        </Text>
        <Spacer size={Spacer.Size.XLarge} />
        <Text as="h3" text={subtitle} type={Text.Type.Subtitle} />
        <div className="u-mobiles-only">
          <Spacer size={Spacer.Size.X2Large} />
        </div>
        <div className="u-desktops-only">
          <Spacer size={Spacer.Size.X4Large} />
        </div>
        {/* eslint-disable-next-line react/no-danger */}
        <div dangerouslySetInnerHTML={{ __html: body }} />
      </div>
    </section>
  )
}

export default InfoPost
